import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/**
 * Shows which build is actually running. Deliberately present on the signed-out
 * screens too: "which version is live?" is a question you most often ask when
 * something is wrong, which is exactly when you may not be able to sign in.
 *
 * The health endpoint is unauthenticated, so this works everywhere.
 */
export function VersionBadge({ className = '' }: { className?: string }) {
  const { data } = useQuery({
    queryKey: ['health'],
    queryFn: api.health,
    staleTime: 60_000,
    retry: false,
  });

  if (!data) return null;

  const { version, semver, commit, builtAt } = data.build;
  const known = commit !== 'unknown';

  const detail = [
    `Version ${semver}`,
    known ? `Commit ${commit}` : 'Commit unknown',
    builtAt ? `Built ${new Date(builtAt).toLocaleString()}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <span className={`num text-xs text-ink-3 ${className}`} title={detail}>
      v{version}
    </span>
  );
}
